import { GenericalRecord } from '../../../../types/utilities'
import { UseStore } from '../../../../types/zustand'
import { useContextStore, useContextStoreApi } from '../../../../utils/zustand'
import { RemoteTableStoreContext } from '../contexts/StoreContext'
import { RemoteTableStore } from '../store/interface'

export const useRemoteTableStore: UseStore<
  RemoteTableStore<GenericalRecord, GenericalRecord>
> = selector => {
  return useContextStore(RemoteTableStoreContext, selector)
}

export const useRemoteTableStoreApi = () => {
  return useContextStoreApi(RemoteTableStoreContext)
}
